import { render, staticRenderFns } from "./NetworkRegionForm.vue?vue&type=template&id=5701dea2"
import script from "./NetworkRegionForm.vue?vue&type=script&lang=js"
export * from "./NetworkRegionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports